import React from 'react';

import { SkipServerRender } from 'components/skip-server-render/skip-server-render';

import { NavigationBanners } from 'components/navigation-banners/navigation-banners';
import { SportsQuickLinks } from 'components/sports-quick-links/sports-quick-links';
import { MostPopularGames } from 'components/most-popular-games/most-popular-games';
import { Producers } from 'components/producers/producers';
// import { PromoPwaInstall } from 'components/promo-pwa-install/promo-pwa-install';
import { RecentlyPlayedGames } from 'components/recently-played-games/recently-played-games';

export const HomeContent = () => (
  <>
    <NavigationBanners className="mb-5" />

    <SportsQuickLinks className="mt-2_5 mt-lg-3_75 mb-5" />

    <RecentlyPlayedGames coreProps={{ size: 200 }} className="mb-2_5 mb-lg-3_75" />

    <MostPopularGames coreProps={{ size: 200 }} />

    <SkipServerRender skip>
      <Producers className="my-2_5 my-lg-3_75" />
    </SkipServerRender>

    {/* <SkipServerRender skip> */}
    {/*  <PromoPwaInstall /> */}
    {/* </SkipServerRender> */}
  </>
);
